import CredentialsModule from './credentials/CredentialsModule';

const CredentialsPage = () => {
  return <CredentialsModule />;
};

export default CredentialsPage;
